/**
 * Utility function for scrolling to top with mobile-friendly behavior
 */
export const scrollToTop = () => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    // Immediate scroll for mobile
    window.scrollTo(0, 0);
    
    // Then smooth scroll after a small delay to ensure content is loaded
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  } else {
    // Desktop browsers handle smooth scroll well
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

/**
 * Check if the current device is mobile
 */
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}; 